import { assign } from 'xstate';



export function convertArrayValuesToInteger(stringArray) {
    if (!Array.isArray(stringArray)) {
        console.warn("convertArrayValuesToInteger wurde nicht mit einem Array aufgerufen:", stringArray);
        return stringArray; // Gibt den ursprünglichen Wert zurück, wenn es kein Array ist
    }

    return stringArray.map(item => {
        // Prüfen, ob der Wert ein String ist und in eine Zahl konvertiert werden kann
        if (typeof item === 'string' && !isNaN(Number(item))) {
            return parseInt(item, 10);
        }
        return item; // Nicht-konvertierbare Werte unverändert zurückgeben
    });
}

export const transformContactFormDataForApi = assign(({ context }) => {
   const vertriebskanal = context.vertriebskanal;
    const rawContactData = context.formData.contactForm;
    const qualificationData = context.qualifikation;
    const building = context.formData.building;


    const salutationToGenderMap = {
        'Herr': 1, // Male
        'Frau': 0, // Female
        'Divers': 3, // Other
    };

    const useDifferentPostalAddress = rawContactData.differentPostalAddress && rawContactData.postalAddress;
    const userPersonData = useDifferentPostalAddress ? rawContactData.postalAddress : rawContactData;
    const userAddressData = useDifferentPostalAddress ? rawContactData.postalAddress : building;
    const instadrPersonData = rawContactData; // Daten für die instadr_ Felder
    const instadrAddressData = building;      // Adressdaten für die instadr_ Felder

    // --- 1. Create User Object ---
    const userObject = {
        person: {
            geschlecht: salutationToGenderMap[userPersonData.salutation] || 0,
            vorname: userPersonData.firstName,
            //telefon: rawContactData.phone,
            mobil: rawContactData.phone,
            nachname: userPersonData.lastName,
            email: rawContactData.email,
            consents: [
                {
                    consent_type: 1,
                    consent: rawContactData.termsAccepted,
                }
            ]
        },
        strasse: userAddressData.street,
        hausnummer: userAddressData.houseNumber,
        plz: userAddressData.zip || userAddressData.zipCode,
        ort: userAddressData.city,
        country: "DE",
        //kundennr: "",
        //erreichbarkeit: [],
        //firma: rawContactData.company,
    };

    // --- 2. Create Project Object ---
    const projectObject = {
        vertragsmodell: 2,
        use_baukasten_features: true
        /*
        paket_uuid: null,
        kit_uuid: "61392770-179c-4206-b27b-ca0d053f41c2",
        kit_modifications: {
            kit_added_blocks: [],
            kit_removed_blocks: []
        },
        */
    };

// Bedingte Hinzufügung von crossdomain_id
    if (context.crossdomainId) {
        projectObject.crossdomain_id = context.crossdomainId;
    }

    // --- Only add instadr_ fields IF a different installation address is specified ---
    if (rawContactData.differentPostalAddress && rawContactData.postalAddress) {
        projectObject.instadr_vorname = instadrPersonData.firstName;
        projectObject.instadr_nachname = instadrPersonData.lastName;
        //projectObject.instadr_firma = rawContactData.installationAddress.company;
        projectObject.instadr_strasse = instadrAddressData.street;
        projectObject.instadr_hausnr = instadrAddressData.houseNumber;
        projectObject.instadr_plz = instadrAddressData.zip;
        projectObject.instadr_ort = instadrAddressData.city;
        //projectObject.instadr_telefon = '';
        //projectObject.instadr_mobil = rawContactData.installationAddress.phone;
        projectObject.instadr_geschlecht = salutationToGenderMap[instadrPersonData.salutation] || 0;
    }

    // --- 3. Dynamically create Qualification Array ---
    const transformedQualifikation = [];

    for (const key in qualificationData) {
        const item = qualificationData[key];
        if (item && item.apiDefinition && item.apiDefinition.parameter !== null && item.apiValue !== null && item.apiDefinition.type) {
            const entry = {
                parameter: parseInt(item.apiDefinition.parameter, 10),
            };

            switch (item.apiDefinition.type) {
                case 'value_choice':
                    entry.value_choice = parseInt(item.apiValue, 10);
                    break;
                case 'value_multiplechoices': {
                    const valuesAsArray = Array.isArray(item.apiValue) ? item.apiValue : [item.apiValue];
                    entry.value_multiplechoices = convertArrayValuesToInteger(valuesAsArray);
                    break;
                }
                case 'value_integer':
                    entry.value_integer = String(item.apiValue);
                    break;
                default:
                    console.warn(`Unknown qualification type: ${item.apiDefinition.type} for parameter ${item.apiDefinition.parameter}`);
                    break;
            }
            transformedQualifikation.push(entry);
        }
    }

    // --- 3b. Rabattcode separat anhängen (kommt aus dem Kontaktformular, nicht aus qualifikation) ---
    if (rawContactData.rabattcode) {
        transformedQualifikation.push({
            parameter: 19409, //19409 -> Rabattcode Photovoltaik, 19410 -> Rabattcode Heizungstausch
            value_text: rawContactData.rabattcode,
        });
    }

    // --- 4. Assemble the complete API JSON object ---
    const finalApiData = {
        frontend_key: "vspvon",
        vertriebskanal: vertriebskanal,
        //produkt_id: 1,
        user: userObject,
        projekt: projectObject,
        //device_type: 2,
        qualifikation: transformedQualifikation,
        //email_vertrieb: "",
        //additionalBundleInclude: false,
    };

    return {
        formData: {
            ...context.formData,
            contactFormApiData: finalApiData,
        }
    };
});
